import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import { ProjectName } from "../constants/main";
import i18nStore from "../i18n/store";


const TermsOfServicePage = observer(() => {
    const translations = i18nStore.getTranslations;

    return (
        <Box>
            <Box>
                <Typography component="h2" variant="h6">
                    {translations._termsOfServicePage.disclaimerOfWarranty}
                </Typography>
                <Typography variant="body1" component="p">
                    {translations._termsOfServicePage.sentence1}<br/>
                    {ProjectName} {translations._termsOfServicePage.sentence2} <br/>
                    {translations._termsOfServicePage.sentence3}
                </Typography>
            </Box>
        </Box>
    );
});

export default TermsOfServicePage;
